import { BaseInitAppService, MenuItem, ModulePwaSettings, ModuleType } from '@shared/core';
import { map } from 'rxjs';

export const createMenuItems = (initAppService: BaseInitAppService) => {
    const fullMenu: MenuItem[] = [
        {
            id: 'Dashboard',
            name: $localize`Dashboard`,
            icon: 'chalkboard',
            link: '/main/home',
            fragment: '',
            unread: false,
        },
        {
            id: 'Policies',
            name: $localize`Policies`,
            icon: 'file-alt',
            link: '/main/insurance-policies',
            fragment: '',
            unread: false,
        },
        {
            id: 'Claims',
            name: $localize`Claims`,
            icon: 'mail-bulk',
            link: '/main/claims',
            fragment: '',
            unread: false,
        },
        {
            id: 'Contact',
            name: $localize`Contact`,
            icon: 'headphones',
            link: '/main/contact',
            fragment: '',
            unread: false,
        },
    ];

    return initAppService.appModules$.pipe(
        map(modules => {
            const mcaConfig = modules?.find(module => module.module === ModuleType.MCA_CONFIG)?.settings as ModulePwaSettings;
            const contacts = mcaConfig?.settings?.contacts || [];
            return contacts && contacts.length > 0 ? fullMenu : fullMenu.filter(item => item.id !== 'Contact');
        }),
    );
};
